<template>
  <div class="most-viewed__wrapper">
    <p v-if="title" class="most-viewed__title blue bold">
      {{ title }}
    </p>
    <div class="most-viewed__items-container">
      <a-visibility hide :from="$breakpoint.desktopSm">
        <a-swiper :swipeList="articles" :customOptions="options">
          <a-most-viewed-item slot-scope="{ slide }" :article="slide" />

          <div class="swiper-button" slot="swiper-prev"></div>
          <div class="swiper-button" slot="swiper-next"></div>
        </a-swiper>
      </a-visibility>

      <a-visibility show :from="$breakpoint.desktopSm">
        <div class="most-viewed__desktop-items-container">
          <a-most-viewed-item
            v-for="(item, index) in articles"
            :key="`${item.Topic}${index}`"
            :article="item"
          />
        </div>
      </a-visibility>
    </div>
  </div>
</template>

<script>
import AMostViewedItem from './AMostViewedItem'
import ASwiper from 'shared/ASwiper'
import { propValidator, PROP_TYPES } from '@/utils/validators'
import scss from '@/utils/scss'
import { serverCacheKey } from '@/utils/mixins/serverCacheKey'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'

const { breakpoints } = scss
const SLIDE_COUNT_BY_BREAKPOINT = {
  [breakpoints.tablet]: 2.2,
  [breakpoints.mobile]: 1.2
}

export default {
  name: 'AMostViewed',
  mixins: [serverCacheKey, hydrationHelpers],
  components: { AMostViewedItem, ASwiper },
  props: {
    title: propValidator([PROP_TYPES.STRING], false),
    articles: propValidator([PROP_TYPES.ARRAY])
  },
  computed: {
    options() {
      const slidesPerView =
        SLIDE_COUNT_BY_BREAKPOINT[
          this.$_hydrationHelpers_getCurrentBreakpoint().value
        ]

      return {
        slidesPerView,
        slidesPerGroup: 1
      }
    }
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>

<style lang="scss" scoped>
.most-viewed__wrapper {
  width: 100%;
}

.most-viewed__title {
  margin-bottom: 20px;
  font-size: 19px;

  @include desktop-sm {
    margin-top: 10px;
  }
}

.most-viewed__items-container {
  display: flex;
  justify-content: space-between;

  @include tablet {
    width: calc(100% + 15px);
  }

  /deep/ .swiper__custom-swiper {
    width: 100%;
    margin: 0;
  }
}

.most-viewed__desktop-items-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.swiper-button {
  display: none;
}
</style>
